import React from 'react';
import { stats } from '../data/site';
export function StatsBar() {
  return <section aria-label="Company track record" className="bg-brand" data-id="element-228" data-mp="1tai1x90mmpqa">
      <div className="mx-auto grid max-w-[1400px] grid-cols-2 divide-white/20 px-5 lg:grid-cols-4 lg:divide-x lg:px-10" data-id="element-229" data-mp="1tb9s24bgfv96">
        {stats.map(stat => <div key={stat.label} className="px-2 py-8 lg:px-8" data-id="element-230" data-mp="1jd3mncqfw6zk">
            <div className="font-display text-4xl font-bold uppercase leading-none text-white lg:text-5xl" data-id="element-231" data-mp="1ed7jtgthalll">
              {stat.value}
            </div>
            <div className="mt-2 font-mono text-[10px] uppercase tracking-[0.22em] text-white/80 lg:text-[11px]" data-id="element-232" data-mp="19lpk0w36yr27">
              {stat.label}
            </div>
          </div>)}
      </div>
    </section>;
}